import { all, fork } from 'redux-saga/effects';
import { watchCreateDependencySaga } from './sagas/create-dependency';
import { watchCreateMultipleSubTaskSaga } from './sagas/create-multiple-sub-tasks';
import { watchCreateSubTaskSaga } from './sagas/create-sub-task';
import { watchCreateTaskSaga } from './sagas/create-task';
import { watchDeleteTaskByIdSaga } from './sagas/delete-task';
import { watchGetTaskByIdSaga } from './sagas/get-task';
import { watchRemoveAsSubtaskSaga } from './sagas/remove_as_subtask';
import { watchSaveTaskDetailSaga } from './sagas/save-task';
import { watchUpdateTaskPrivacySaga } from './sagas/update-privacy';
import { watchUpdateTaskSaga, watchUpdateTaskDatesSaga } from './sagas/update-task';
export const taskRootSaga = function*() {
    yield all([
        fork(watchGetTaskByIdSaga),
        fork(watchSaveTaskDetailSaga),
        fork(watchUpdateTaskSaga),
        fork(watchUpdateTaskDatesSaga),
        fork(watchCreateTaskSaga),
        fork(watchDeleteTaskByIdSaga),
        fork(watchCreateSubTaskSaga),
        fork(watchCreateMultipleSubTaskSaga),
        fork(watchUpdateTaskPrivacySaga),
        fork(watchCreateDependencySaga),
        fork(watchRemoveAsSubtaskSaga)
    ]);
};
